import { IntlShape } from 'react-intl';

import { holdMessages } from '@app/translations';
import { HOLD_STATUS_MESSAGE_MAP } from '@app/utils/getItemStatusData';

export const getStatusMessage = (
  status: string,
  intl: IntlShape,
  queuePosition?: number
) => {
  const statusMessage = HOLD_STATUS_MESSAGE_MAP[status];

  return statusMessage === holdMessages.queue && !queuePosition
    ? ''
    : intl.$t(statusMessage, { value: queuePosition });
};
